export default __webpack_public_path__ + "4fb0be683c183396bde16193d7a8b0ac.png";